<template>
  <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
    <template #activator="{ on, attrs }">
      <slot :downloadFile="downloadFile" :loading="loading">
        <v-btn
          v-bind="{ ...$attrs, ...attrs }"
          v-on="on"
          :loading="loading"
          class="new_style"
          @click="downloadFile"
        >
          <vue-icon icon="newFileDownloadIcon"></vue-icon>
        </v-btn>
      </slot>
    </template>
    <span>{{ $t(hint) }}</span>
  </v-tooltip>
</template>

<script>
import { downloadBlobFile } from "@/utils/pureFunctions";

export default {
  name: "downloader",
  props: {
    btnClass: {
      type: String,
      default: "primary",
    },
    address: {
      type: String,
    },
    fileName: String,
    hint: {
      default: "downloadFile",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async downloadFile() {
      try {
        this.loading = true;
        const data = await this.$store.dispatch(
          "getAttachmentFile",
          this.address
        );
        downloadBlobFile(data, this.fileName);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
